import { VStack, Button, Spinner } from "@chakra-ui/react";
import { ChatMessage } from "./ChatMessage";
import { useChatStore } from "../../stores/chatStore";
import { useTranslation } from "react-i18next";
import { ChatSessionType } from "../../types";

interface ChatMessagesProps {
  bg: string;
  messagesEndRef: any;
  index: number;
  sessionId?: string;
}

export const ChatMessages = ({
  bg,
  messagesEndRef,
  index,
  sessionId,
}: ChatMessagesProps) => {
  const { currentSession, hasMoreMessages, isLoadingMore, loadOlderMessages } =
    useChatStore();
  const { t } = useTranslation();
  return (
    <VStack
      // flex={1}
      mt={57}
      mb={112}
      p={4}
      spacing={4}
      overflowY="auto"
      bg={bg}
      // align="stretch"
      // NEW TESTS
      // maxH="82vh"
    >
      {hasMoreMessages && (
        <Button
          onClick={loadOlderMessages}
          isLoading={isLoadingMore}
          loadingText="Loading..."
          size="sm"
          colorScheme="brand"
          fontFamily="Nasalization"
          variant="ghost"
          mb={2}
        >
          {t("chat.loadMoreMessages")}
        </Button>
      )}
      {currentSession?.messages
        ?.filter(
          (message) =>
            currentSession.sessionType === ChatSessionType.STANDARD ||
            message.index === index
        )
        .map((message, i) => (
          <ChatMessage
            key={`${message.id}-${message.content}`}
            message={message}
            index={index}
            sessionType={currentSession.sessionType}
            {...(sessionId ? { sessionId } : {})}
          />
        ))}
      <div ref={messagesEndRef} />
    </VStack>
  );
};
